import React from "react";
import loadable from '@loadable/component';
import { Routes, Route } from "react-router";
import CssBaseline from '@mui/material/CssBaseline';
import NavBar from './shared/navbar';
import AppTheme from './shared/theme/AppTheme';
import {
  chartsCustomizations,
  dataGridCustomizations,
  datePickersCustomizations,
  treeViewCustomizations,
} from './shared/theme/customizations';
import './App.scss';
import { clearTableData } from './pages/browse/browseDataCache';

const Home = loadable(() => import('./pages/home'));
const BrowseLanding = loadable(() => import('./pages/browse/browseLanding'));
const Browse = loadable(() => import('./pages/browse'));
const Search = loadable(() => import('./pages/search'));
const Download = loadable(() => import('./pages/download'));
const About = loadable(() => import('./pages/about'));
const Statistics = loadable(() => import('./pages/statistics'));
const Help = loadable(() => import('./pages/help'));
const Contact = loadable(() => import('./pages/contact'));
const Timeline = loadable(() => import('./pages/timeline'));
const CompoundDetail = loadable(() => import('./pages/compound/CompoundDetail'));
const ComplexDetail = loadable(() => import('./pages/complex/ComplexDetail'));
const CitationDetail = loadable(() => import('./pages/citation/CitationDetail'));

const xThemeComponents = {
  ...chartsCustomizations,
  ...dataGridCustomizations,
  ...datePickersCustomizations,
  ...treeViewCustomizations,
};

interface AppProps {}

interface AppState {}

export default class App extends React.Component<AppProps, AppState> {
  // Clear table cache when leaving the app
  componentWillUnmount() {
    clearTableData();
  }

  render() {
    return (
      <AppTheme {...this.props} themeComponents={xThemeComponents}>
        <CssBaseline enableColorScheme />
        <div className="app">
          <div className="app-nav">
            <NavBar />
          </div>
          <main className="app-main">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/browse" element={<BrowseLanding />} />
              <Route path="/browse/compounds" element={<Browse tableType="compounds" />} />
              <Route path="/browse/complexes" element={<Browse tableType="complexes" />} />
              <Route path="/browse/citations" element={<Browse tableType="citations" />} />
              <Route path="/search" element={<Search />} />
              <Route path="/compound/:id" element={<CompoundDetail />} />
              <Route path="/complex/:id" element={<ComplexDetail />} />
              <Route path="/citation/:id" element={<CitationDetail />} />
              <Route path="/download" element={<Download />} />
              <Route path="/about" element={<About />} />
              <Route path="/statistics" element={<Statistics />} />
              <Route path="/help" element={<Help />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/timeline" element={<Timeline />} />
            </Routes>
          </main>
        </div>
      </AppTheme>
    );
  }
}